import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { twMerge } from 'tailwind-merge';

import './style.css';

interface MarkdownProps {
  children: string;
  containerClassName?: string;
}

const Markdown: React.FC<MarkdownProps> = ({
  children,
  containerClassName,
}) => (
  <ReactMarkdown
    data-testid="markdown"
    className={twMerge(
      'custom-markdown',
      'text-neutral-90',
      containerClassName,
    )}
    rehypePlugins={[rehypeRaw]}
  >
    {children}
  </ReactMarkdown>
);

export default Markdown;
